import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: {
        id: string
    }
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.staticEnums
function* staticEnumsSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/static-enums`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* staticEnumsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, staticEnumsSagaTask)
}

export default staticEnumsSaga
